// src/components/live/LiveLeaderboard.js
import React, { useState, useEffect } from 'react';
import { FaTrophy, FaCrown, FaMedal, FaAward, FaSync } from 'react-icons/fa';
import { liveAPI } from '../../services/api';

const LiveLeaderboard = ({ sessionId }) => {
  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchLeaderboard = async () => {
    try {
      const data = await liveAPI.getLeaderboard(sessionId);
      setLeaderboard(data.leaderboard || []);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (sessionId) {
      fetchLeaderboard();
      
      // Refresh every 10 seconds for real-time updates
      const interval = setInterval(fetchLeaderboard, 10000);
      return () => clearInterval(interval);
    }
  }, [sessionId]);

  if (loading) {
    return (
      <div className="bg-white rounded-2xl border border-gray-200 p-4 animate-pulse">
        <div className="h-6 bg-gray-200 rounded mb-4"></div>
        <div className="space-y-2">
          {[1,2,3].map(i => (
            <div key={i} className="h-12 bg-gray-200 rounded"></div>
          ))}
        </div>
      </div>
    );
  }

  if (leaderboard.length === 0) {
    return (
      <div className="bg-white rounded-2xl border border-gray-200 p-6 text-center">
        <FaTrophy className="w-8 h-8 text-gray-400 mx-auto mb-2" />
        <p className="text-gray-600">No results published yet</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900 flex items-center">
          <FaTrophy className="w-5 h-5 text-yellow-500 mr-2" />
          Live Leaderboard
        </h3>
        <button
          onClick={fetchLeaderboard}
          className="p-2 text-gray-600 hover:text-gray-800 rounded-lg hover:bg-gray-100"
        >
          <FaSync className="w-4 h-4" />
        </button>
      </div>

      <div className="space-y-3">
        {leaderboard.map((participant, index) => (
          <div 
            key={participant.userId} 
            className={`flex items-center justify-between p-3 rounded-xl ${
              index === 0 ? 'bg-yellow-50 border border-yellow-200' :
              index === 1 ? 'bg-gray-50 border border-gray-200' :
              index === 2 ? 'bg-orange-50 border border-orange-200' :
              'bg-gray-50'
            }`}
          >
            <div className="flex items-center space-x-3">
              <div className="flex items-center space-x-2">
                {index === 0 && <FaCrown className="w-4 h-4 text-yellow-500" />}
                {index === 1 && <FaMedal className="w-4 h-4 text-gray-500" />}
                {index === 2 && <FaAward className="w-4 h-4 text-orange-500" />}
                <span className="font-semibold text-gray-900">#{index + 1}</span>
              </div>
              <div>
                <p className="font-medium text-gray-900">{participant.name}</p>
                <p className="text-xs text-gray-600">{participant.category}</p>
              </div>
            </div>
            <div className="text-right">
              <p className="text-lg font-bold text-green-600">{participant.totalScore || 0}</p>
              <p className="text-xs text-gray-500">points</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LiveLeaderboard;